//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    Fragment
  },
  props: {
    text: {
      type: String,
      required: true
    },
    breakLine: {
      type: Boolean,
      default: false
    }
  }
});